module.exports = __webpack_public_path__ + "img/033_thumbnail.e1cebd14.jpg";